export default __webpack_public_path__ + "static/media/frame-wood-no-corners.57dda93e.png";